import { SUB_ACCOUNT_ID } from '../../../config'
import { AccountInterface } from 'starknet'
import { Web3Provider } from '@ethersproject/providers'
import { Address, L1ChainId, TokenAddress } from '../../../types'
import { BigNumberish, ethers } from 'ethers'
import { sendDepositFromEthereum } from './sendDepositFromEthereum'
import { ChainType } from '../../../constants/chains'
import { sendDepositFromStarknet } from './sendDepositFromStarknet'
import toastify from '../../../components/Toastify'
import { NetworkRegistry } from '../../../utils/networkRegistry'

export interface DepositResult {
  chainId: string // Deposit chain ID, e.g. "0xa"
  hash: string // Transaction hash, e.g. "0x..."
  from: string // Sender address, e.g. "0x..."
}

export async function sendDeposit(
  provider: AccountInterface | Web3Provider,
  payload: {
    chainId: L1ChainId
    from: Address
    depositTo: Address
    token: TokenAddress
    amount: BigNumberish
    ethTxOptions?: ethers.providers.TransactionRequest
    approveDepositAmountForERC20?: boolean
  },
): Promise<DepositResult> {
  const chain = NetworkRegistry.byL1(payload.chainId)
  if (!chain) {
    throw new Error(`Unknown network ${payload.chainId} on sendDeposit`)
  }

  if (chain.chainType === ChainType.Starknet) {
    return await sendDepositFromStarknet(provider as AccountInterface, {
      subAccountId: SUB_ACCOUNT_ID,
      mapping: false,
      ...payload,
    })
  } else {
    return await sendDepositFromEthereum(provider as Web3Provider, {
      subAccountId: SUB_ACCOUNT_ID,
      mapping: false,
      ...payload,
    })
  }
}

export function onDepositConfirmation() {
  toastify.success(
    'Your deposit transaction has been mined, please wait for a few confirmations.',
  )
}
